import { Component, computed, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCircleCheck,
  faCircleXmark,
  faTriangleExclamation,
  faCircleInfo,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

import { ToastService, Toast, ToastType } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
})
export class ToastComponent {

  protected readonly toastService = inject(ToastService);

  protected readonly topRightToasts    = computed(() => this.toastService.toasts().filter(t => t.position === 'top-right'));
  protected readonly bottomRightToasts = computed(() => this.toastService.toasts().filter(t => t.position === 'bottom-right'));

  protected readonly faCircleCheck         = faCircleCheck;
  protected readonly faCircleXmark         = faCircleXmark;
  protected readonly faTriangleExclamation = faTriangleExclamation;
  protected readonly faCircleInfo          = faCircleInfo;
  protected readonly faXmark               = faXmark;

  protected iconFor(type: ToastType) {
    return {
      success: this.faCircleCheck,
      error:   this.faCircleXmark,
      warning: this.faTriangleExclamation,
      info:    this.faCircleInfo,
    }[type];
  }

  protected dismiss(id: number): void {
    this.toastService.dismiss(id);
  }

  protected trackById(_: number, toast: Toast): number {
    return toast.id;
  }
}
